import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Season } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Season";

/** Playing seasons. One is current per club. */
export const SeasonService = {
	endpoint,
	createSingle: async (data: Season) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Season) => await Service.updateSingleById(endpoint, id, data),
	getCurrent: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Current`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	setCurrent: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/${id}/SetCurrent`, {headers: {"Content-Type": "application/json"}, method: "POST"})
}
